/* src/messages/cards/MessageCard/styles.js */

export default theme => {
  const { unit } = theme.spacing;
  const padding = unit * 3;
  const textPadding = unit * 1.5;
  const connectedBorderRadius = 3;
  const marginLeft = 38;

  return {
    card: {
      height: 'calc(100vh - 108px)',
    },
    header: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'sticky',
      padding,
    },
    resolveButton: {
      position: 'absolute',
      right: padding,
      top: padding,
    },
    input: {
      alignItems: 'center',
    },
    inputContainer: {
      display: 'flex',
      flex: 1,
    },
    footer: {
      padding,
      display: 'flex',
      flexDirection: 'row',
      bottom: 0,
    },
    body: {
      height: '76%',
      overflow: 'auto',
      backgroundColor: theme.palette.background.default,
      padding,
      paddingLeft: unit,
    },
    bubble: {
      padding: unit,
      paddingLeft: textPadding,
      paddingRight: textPadding,
      maxWidth: '40%',
      borderRadius: 20,
      display: 'inline-block',
      backgroundColor: theme.palette.primary.main,
      marginBottom: 1,
    },
    bubbleRight: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    lastBubble: {
      marginLeft: 0,
    },
    bubbleContainer: {
      flexDirection: 'row',
      display: 'flex',
    },
    'firstBubble-me': {
      borderBottomRightRadius: connectedBorderRadius,
    },
    'middleBubble-me': {
      borderBottomRightRadius: connectedBorderRadius,
      borderTopRightRadius: connectedBorderRadius,
    },
    'lastBubble-me': {
      borderTopRightRadius: connectedBorderRadius,
    },
    'firstBubble-other': {
      borderBottomLeftRadius: connectedBorderRadius,
      marginLeft,
    },
    'middleBubble-other': {
      borderBottomLeftRadius: connectedBorderRadius,
      borderTopLeftRadius: connectedBorderRadius,
      marginLeft,
    },
    'lastBubble-other': {
      borderTopLeftRadius: connectedBorderRadius,
      marginLeft: unit,
    },
    'loneBubble-other': {
      marginLeft: unit,
    },
    messageText: {
      color: 'white',
    },
    dateContainer: {
      display: 'flex',
      justifyContent: 'center',
      padding: unit,
    },
    avatar: {
      width: 30,
      height: 30,
      display: 'inline-flex',
      alignSelf: 'center',
    },
    pendingFooter: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      height: '100%',
    },
    time: {
      marginRight: theme.spacing.unit,
      marginLeft: theme.spacing.unit,
      marginTop: theme.spacing.unit,
    },
    none: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      padding: theme.spacing.unit * 2,
    },
  };
};



// WEBPACK FOOTER //
// ./src/modules/messages/cards/MessageCard/styles.js